import React, {useEffect, useState, useRef, useContext} from 'react';
import {PageHeader, Table, Input, Button, Space, notification} from 'antd';
import {getWelcomelist, getWelcomeAttachList, delWelcomeConfig} from '@/api/customer';
import {useAuthStore} from '@/context/auth';
import _ from 'lodash';
import {FileOutlined, PlusOutlined, DeleteOutlined, EditOutlined} from '@/icons';
import styles from '@/page/customer/index.module.less';
import classNames from 'classnames';
import WelcomeModal from '@/page/customer/RoomWelcomPage/WelcomeModal';
import MsgContext from '@/page/customer/RoomWelcomPage/msgContext';
import {formatLong} from '@/util/dateUtils';
import {PageGrid} from '@/component';
import {getAttach} from '@/api/attach';
import {useEditAuthService} from '@/page/admin/adminService';

const CONFIG_TYPE = 'room';
export default function RoomWelcomPage() {
    const editable = useEditAuthService(['global:customer_room_welcom_mgr:w']);
    const [authStore] = useAuthStore();
    const extId = _.get(authStore, 'user.extId');
    const [viewText, setViewText] = useState(null);
    const [viewLinks, setViewLinks] = useState([]);
    const [viewImages, setViewImages] = useState([]);
    const [viewWebApps, setViewWebApps] = useState([]);
    const [viewFiles, setViewFiles] = useState([]);
    const [viewVideos, setViewVideos] = useState([]);
    const [url, setUrl] = useState(null);
    const [sender, setSender] = useState(extId);

    const wlRef = useRef();
    const tableRef = useRef();

    const columns = [
        {
            title: '配置id',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: '欢迎语素材id',
            dataIndex: 'extId',
            key: 'extId',
        },
        {
            title: '欢迎文字',
            dataIndex: 'content',
            key: 'content',
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
            render: text => {
                return formatLong(text);
            },
        },
        {
            title: '操作',
            key: 'action',
            width: 100,
            render: (text, record) => (
                <Space>
                    <Button type="link" icon={<FileOutlined />} onClick={() => view(record)}>
                        查看详细
                    </Button>
                    <Button
                        disabled={!editable}
                        type="link"
                        icon={<EditOutlined />}
                        onClick={() => {
                            edit(record);
                        }}
                    >
                        编辑
                    </Button>
                    <Button
                        disabled={!editable}
                        danger
                        type="link"
                        icon={<DeleteOutlined />}
                        onClick={() => {
                            del(record);
                        }}
                    >
                        删除
                    </Button>
                </Space>
            ),
        },
    ];

    let extra = (
        <Button type="primary" icon={<PlusOutlined />} onClick={add} disabled={!editable}>
            添加
        </Button>
    );

    useEffect(() => {
        setUrl('/customer/welcome/list?extId=' + extId + '&type=' + CONFIG_TYPE);
        // init();
    }, []);

    function add() {
        reset();
        wlRef.current.open(1);
    }

    function del(record) {
        delWelcomeConfig(record.id).then(res => {
            if (res.status == 200) {
                init();
                notification.success({
                    message: '删除成功',
                });
            }
        });
    }

    function edit(record) {
        reset();
        setViewText(record.content);
        getWelcomeAttachList(record.id).then(res => {
            if (res.data.length > 0) {
                res.data.forEach(item => {
                    let {msgType} = item;
                    if (msgType === 'link') {
                        setViewLinks(
                            new Array({
                                title: item.title,
                                desc: item.linkDesc,
                                url: item.url,
                                attachId: item.mediaAttachId,
                                picurl: item.picUrl,
                            })
                        );
                    }
                    if (item.msgType === 'image') {
                        setViewImages(new Array(item.sysAttach));
                    }
                    if (item.msgType === 'file') {
                        setViewFiles(new Array(item.sysAttach));
                    }
                    if (item.msgType === 'video') {
                        setViewVideos(new Array(item.sysAttach));
                    }
                    if (item.msgType === 'webApp') {
                        setViewWebApps(
                            new Array({
                                title: item.title,
                                pic_media_id: item.pic_media_id,
                                appid: item.appid,
                                page: item.page,
                                pic_url: item.picUrl,
                            })
                        );
                    }
                });
            }
            setTimeout(() => {
                wlRef.current.open(2, record.id);
            }, 500);
        });
    }

    function view(record) {
        reset();
        setViewText(record.content);
        getWelcomeAttachList(record.id).then(res => {
            console.log(res.data);
            if (res.data.length > 0) {
                res.data.forEach(item => {
                    let {msgType} = item;
                    if (msgType === 'link') {
                        setViewLinks(
                            new Array({
                                title: item.title,
                                desc: item.linkDesc,
                                url: item.url,
                                attachId: item.mediaAttachId,
                                picurl: item.picUrl,
                            })
                        );
                    }
                    if (item.msgType === 'image') {
                        setViewImages(new Array(item.sysAttach));
                    }
                    if (item.msgType === 'file') {
                        setViewFiles(new Array(item.sysAttach));
                    }
                    if (item.msgType === 'video') {
                        setViewVideos(new Array(item.sysAttach));
                    }
                    if (item.msgType === 'webApp') {
                        setViewWebApps(
                            new Array({
                                title: item.title,
                                pic_media_id: item.pic_media_id,
                                appid: item.appid,
                                page: item.page,
                                pic_url: item.picUrl,
                            })
                        );
                    }
                });
            }

            wlRef.current.open(3);
        });
    }

    function reset() {
        setViewImages([]);
        setViewText(null);
        setViewLinks([]);
        setViewWebApps([]);
        setViewVideos([]);
        setViewFiles([]);
    }

    function init() {
        tableRef.current.reload2FirstPage();
    }

    return (
        <MsgContext.Provider
            value={{
                viewText,
                setViewText,
                viewImages,
                setViewImages,
                viewLinks,
                setViewLinks,
                viewWebApps,
                setViewWebApps,
                viewFiles,
                setViewFiles,
                viewVideos,
                setViewVideos,
                sender,
            }}
        >
            <div className={styles.header}>
                <PageHeader title={'群欢迎语配置'} extra={extra} />
            </div>
            <div className={classNames(styles.tableContainer, styles.tabContainer)}>
                {url && <PageGrid ref={tableRef} url={url} columns={columns} />}
            </div>
            <WelcomeModal ref={wlRef} reload={init} />
        </MsgContext.Provider>
    );
}
